import { useDisclosure } from '@tradener/lumen';

function useComplementDialog() {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();

  return { isOpen, onOpen, onClose, onToggle };
}

export default useComplementDialog;
